<!-- Desktop: dropdown behavior -->
<span nz-dropdown
  class="hamburger-dropdown-icon-container hamburger-trigger hamburger-trigger--desktop"
  [nzDropdownMenu]="hamburgerDropdownPanel"
  [nzTrigger]="'click'"
  [nzPlacement]="'bottomRight'"
  [nzClickHide]="true"
  (nzVisibleChange)="onDesktopVisibleChange($event)"
>
  <ng-container
    *ngTemplateOutlet="hamburgerToggleTemplate; context: { isOpen: desktopOpen }"
  ></ng-container>
</span>
<nz-dropdown-menu #hamburgerDropdownPanel="nzDropdownMenu" class="hamburger-menu--desktop">
  <div class="app-hamburger-panel">
    <liberro-basic-layout-hamburger-menu
      (logoutBtnClick)="onLogoutClick()"
      data-cy="logout-btn"
    ></liberro-basic-layout-hamburger-menu>
  </div>
</nz-dropdown-menu>

<!-- Mobile: full-screen overlay, no dropdown -->
<span
  class="hamburger-dropdown-icon-container hamburger-trigger hamburger-trigger--mobile"
  (click)="onToggleMobile()"
>
  <ng-container
    *ngTemplateOutlet="hamburgerToggleTemplate; context: { isOpen: mobileOpen }"
  ></ng-container>
</span>
@if (mobileOpen) {
  <div
    class="mobile-hamburger-overlay"
    [@mobileHamburgerSlide]
    [style.padding-bottom]="nativeSafeZoneService.paddings.navbarHeight + 'px'"
    [style.top]="nativeSafeZoneService.paddings.top + 'px'"
  >
    <div class="logo"></div>
    <ul nz-menu class="mobile-hamburger-overlay-menu">
      <liberro-basic-layout-hamburger-menu
        (logoutBtnClick)="onLogoutClick(true)"
        (menuItemClick)="onMobileItemClick()"
        data-cy="logout-btn"
      ></liberro-basic-layout-hamburger-menu>
    </ul>
    <liberro-basic-layout-footer
      variant="mobile-hamburger"
      [hotlineAvailability]="null"
      [links]="links()"
    ></liberro-basic-layout-footer>
  </div>
}

<ng-template #hamburgerToggleTemplate let-isOpen="isOpen">
  @if (!isOpen) {
    <svg-icon
      class="bwm-hamburger pointer"
      [src]="'assets/icons/bwm-hamburger.svg'"
      data-cy="header-hamburger-icon"
    ></svg-icon>
  } @else {
    <a nz-button
      nzType="link"
      [nzDanger]="'bwm' | appMode"
      class="close-hamburger action-btn"
    >
      {{ 'header.close' | translate }}
      <svg-icon
        class="close-hamburger-icon"
        [src]="'assets/icons/cross.svg'"
      ></svg-icon>
    </a>
  }
</ng-template>

